<script setup lang="ts">
import { PropType } from 'vue'

/* Types */
import { Banner } from '@/store/banners/banners.types'

const props = defineProps({
  slide: {
    type: Object as PropType<Banner>,
    required: true,
  },
})
</script>

<template>
  <nuxt-link
    v-if="props.slide.url"
    :to="props.slide.url"
    class="carousel__slide"
  >
    <nuxt-img
      class="carousel__slide-link"
      :alt="props.slide.name"
      :src="props.slide.image_mobile"
    />
  </nuxt-link>
  <nuxt-img
    v-else
    class="carousel__slide-image"
    :alt="props.slide.name"
    :src="props.slide.image_mobile"
  />
</template>

<style lang="scss">
.carousel__slide {
  img,
  &-image {
    display: block;
    width: 100%;
    height: 100%;
    margin-right: 20px;
    border-radius: 20px;
    @include media('>=desktop-mini') {
      margin-right: 0;
      border-radius: 30px;
    }
  }
}
</style>
